<template>
  <FreeGallery class="mb-3 md:mb-6 [&_.swiper-container]:!overflow-visible [&_.swiper-wrapper]:!justify-between">
    <div
      v-for="(x, index) in ['left', 'right']"
      :key="index"
      class="swiper-slide flex !w-min items-center"
    >
      <slot :name="x" />
    </div>
  </FreeGallery>
</template>
